import { Configuration, LogLevel } from "@azure/msal-browser";

// Auth config returned from the API
export interface AuthConfig {
  tenantId: string;
  clientId: string;
  authority: string;
  knownAuthority: string;
}

// Fallback values for POCSWAB2C CIAM
const FALLBACK_CONFIG: AuthConfig = {
  tenantId: "POCSWAB2C.onmicrosoft.com",
  clientId: "929f73a2-9acf-4c2f-9de7-9afad386a761",
  authority: "https://POCSWAB2C.ciamlogin.com/POCSWAB2C.onmicrosoft.com",
  knownAuthority: "POCSWAB2C.ciamlogin.com",
};

// Fetch auth config from the API
export async function fetchAuthConfig(): Promise<AuthConfig> {
  try {
    const response = await fetch("/api/auth/config");
    if (!response.ok) {
      return FALLBACK_CONFIG;
    }
    const config = await response.json();
    return {
      tenantId: config.tenantId || FALLBACK_CONFIG.tenantId,
      clientId: config.clientId || FALLBACK_CONFIG.clientId,
      authority: config.authority || FALLBACK_CONFIG.authority,
      knownAuthority: config.knownAuthority || FALLBACK_CONFIG.knownAuthority,
    };
  } catch {
    return FALLBACK_CONFIG;
  }
}

// Create MSAL configuration from auth config
export function createMsalConfig(authConfig: AuthConfig): Configuration {
  return {
    auth: {
      clientId: authConfig.clientId,
      authority: authConfig.authority,
      knownAuthorities: [authConfig.knownAuthority],
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
            case LogLevel.Info:
              console.info(message);
              break;
            case LogLevel.Verbose:
              console.debug(message);
              break;
          }
        },
      },
    },
  };
}

// Scopes to request during login
// Note: Email is retrieved via backend Graph API using client credentials, not user tokens
export const loginRequest = {
  scopes: ["openid", "profile"],
};

